import { TextContentMessageBox } from "./assets/windows/WindowMessageBox/modelsMessageBox";
import { StateActionPermission } from "./models/models";

export const FeatureName = {
    LICENCE: "licence",
    PRODUCT: "product",
    PROJECT: "project",
    MIGRATED_PRODUCT: "migrated product",
    FEATURE: "feature",
    USERS: "user",
} as const;

export type FeatureNamePermission =
    (typeof FeatureName)[keyof typeof FeatureName];

export const deleteAllKeysText = (): TextContentMessageBox => ({
    title: "Are you sure you wish to delete selected key(s)?",
    text: "These actions are not reversible!",
});

export const generateFileWithKeysText = (
    count: number
): TextContentMessageBox => ({
    title: `Generate file with ${count} keys?`,
    text: "This may take a while",
});

export const generateAttentionTableKeysText = (
    limit: number
): TextContentMessageBox => ({
    title: `Attention!`,
    text: `If you need to generate more than ${limit} licenses, please use the "Generate to File" option.`,
});

export const licenseGenerationNotAllowedText = (): TextContentMessageBox => ({
    title: "License generation is not available",
    text: "Your account has no license generation permission. Please contact your administrator to request it.",
});

export const actionText = (
    stateAction: StateActionPermission,
    featureName: FeatureNamePermission
): TextContentMessageBox => ({
    title: `Are you sure you wish to ${stateAction} ${featureName}?`,
});
